import { LogicContext } from '@/logic/main/types';

export const prepareJackpotsContent = async (context: LogicContext) => {
  const { jackpots } = context;

  if (!jackpots) {
    return { updates: [] };
  }

  let updates = [];

  for (const jackpotsByCode of Object.values(jackpots)) {
    for (const jackpot of Object.values(jackpotsByCode)) {
      if (!jackpot.components || !jackpot.components.length || !jackpot.fieldsValues) {
        continue;
      }

      updates.push(
        ...jackpot.components.map((componentId: string) => ({
          type: 'setLayoutProperty',
          data: {
            path: `components.${componentId}.properties`,
            value: {
              feed: {
                ...jackpot.fieldsValues,
                timestamp: new Date().toISOString() // added because it is also present in older logic for fetching Jackpot /src/utils/jackpotsV2/getJackpotsForJPTiles.ts:32
              },
            },
          },
        }))
      );
    }
  }

  return { updates };
};

